import { Stack, Text } from 'braid-design-system';
import type { FC } from 'react';

import type {
  Verification,
  VerificationViewField,
} from '../../../AppPageBlock/graphql/hirer-types.generated';
import { ProfileDetails } from '../Profile/ProfileDetails';
import { ProfileSection } from '../Profile/ProfileSection';

interface Props {
  heading: string;
  tooltip?: string;
  verifications: Verification[];
}

export const VerificationsItem: FC<Props> = ({
  heading,
  tooltip,
  verifications,
}) => {
  if (verifications.length === 0) {
    return null;
  }

  const toDescriptionList = ({ label, value }: VerificationViewField) => ({
    name: label,
    values: value,
  });

  return (
    <ProfileSection title={heading} tooltip={tooltip}>
      <Stack space="large">
        {verifications.map(({ title, viewFields }, index) => (
          <Stack key={title || index.toString()} space="small">
            {title ? <Text weight="strong">{title}</Text> : null}
            <ProfileDetails details={viewFields.map(toDescriptionList)} />
          </Stack>
        ))}
      </Stack>
    </ProfileSection>
  );
};
